module.exports = __webpack_public_path__ + "img/place-hsh.044c3252.png";